(function(){
  if (window.__sophiaBag) return; window.__sophiaBag = true;
  /* every cart surface on the page: the bag page (cart-items-component) and the drawer (cart-drawer-items) */
  var cartIds = function(){
    var seen = {};
    return [].slice.call(document.querySelectorAll('cart-items-component[data-section-id], cart-drawer-items[data-section-id]'))
      .map(function(c){ return c.dataset.sectionId; }).filter(function(id){ return id && !seen[id] && (seen[id] = true); });
  };
  var pairsId = function(){ var p=document.querySelector('[data-sophia-pairs-section]'); return p && p.dataset.sophiaPairsSection; };
  function apply(sections){
    if (!sections) return;
    var pid = pairsId();
    if (pid && sections[pid]) {
      var n = new DOMParser().parseFromString(sections[pid], 'text/html').querySelector('[data-sophia-pairs-section]');
      var o = document.querySelector('[data-sophia-pairs-section]');
      if (n && o) o.replaceWith(n);
    }
    var only = {};
    cartIds().forEach(function(id){ if (sections[id]) only[id] = sections[id]; });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { sections: only } }));
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = c.item_count; });
    }).catch(function(){});
  }
  async function post(url, body){
    body.sections = cartIds().concat(pairsId() ? [pairsId()] : []).join(',');
    body.sections_url = location.pathname;
    var r = await fetch(url, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify(body) });
    var d = await r.json();
    if (!r.ok || d.status) throw d;
    apply(d.sections);
    return d;
  }
  function busy(el, on){ if (!el) return; el.toggleAttribute('aria-busy', on); el.disabled = on; }
  document.addEventListener('click', async function(e){
    var add = e.target.closest('[data-sophia-add]');
    if (add) {
      e.preventDefault();
      var box = add.closest('[data-sophia-chain-offer]'), v = box.querySelector('[data-sophia-chain-variant]');
      var err = box.querySelector('.sophia-chain-offer__error');
      busy(add, true); if (err) err.hidden = true;
      try { await post('/cart/add.js', { items: [{ id: Number(v.value), quantity: 1 }] }); }
      catch (x) { if (err) err.hidden = false; busy(add, false); }
      return;
    }
    var pa = e.target.closest('button[data-sophia-pairs-add]');
    if (pa) {
      e.preventDefault(); busy(pa, true);
      try { await post('/cart/add.js', { items: [{ id: Number(pa.dataset.sophiaPairsAdd), quantity: 1 }] }); }
      catch (x) { busy(pa, false); }
    }
  });
  document.addEventListener('change', async function(e){
    var g = e.target.closest('[data-sophia-giftwrap]');
    if (!g) return;
    var id = Number(g.dataset.sophiaGiftwrap); busy(g, true);
    try {
      if (g.checked) await post('/cart/add.js', { items: [{ id: id, quantity: 1 }] });
      else await post('/cart/change.js', { id: String(id), quantity: 0 });
    } catch (x) { g.checked = !g.checked; busy(g, false); }
  });
})();
